<template>
  <div class="d-profile__form">
    <div class="d-profile__form__edit" v-if="!isEditable && canEdit" @click="isEditable = true">{{ $t('vue2.common.edit') }}</div>
    <div class="d-input-group__un-edit" v-if="!isEditable">
      <h3>CPR nummer</h3>
      <p>{{ ssnHidden }}</p>
    </div>
    <template v-else>
      <div class="d-input-group">
        <label>CPR nummer</label>
        <input type="text"
               v-model.trim="ssn"
               @keyup="removeErrors('ssn')"
               :class="{'input--error': formErrors['ssn']}">
        <p class="input-error" v-if="formErrors['ssn']">
          {{ formErrors['ssn'] }}
        </p>
      </div>
      <div class="d-profile__form__submit">
        <button @click="cancel">{{ $t('vue2.common.cancel') }}</button>
        <button class="bttn submit-button" @click="submit"
                :class="[
                    {'bttn--loading': isSaving},
                    {'submit-button--disabled': isSaveButtonDisabled}
                    ]">
          {{ $t('vue2.common.save') }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import Loader from '../common/Loader'
import docendo from '../../docendo'
import eventbus from '../../eventbus'

export default {
  components: {Loader},
  props: {
    user: {
      default: null
    },
    users: {
      default: () => []
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEditable: false,
      formErrors: {},
      ssn: '',
      isSaving: false
    }
  },
  computed: {
    ssnTrimmed () {
      let cpr = this.ssn.replace(/[^0-9]/ig, '')
      return cpr.toString()
    },
    isSaveButtonDisabled () {
      return this.ssn.replace(/[^0-9]/ig, '').length !== 10
    },
    ssnHidden () {
      let ssnText = 'Ikke udfyldt'
      if (this.ssn.length > 0) {
        ssnText = this.ssn
        if (this.ssn.length > 5) {
          let replacement = 'xxxx'
          ssnText = ssnText.slice(0, -4) + replacement
        }
      }
      return ssnText
    }
  },
  methods: {
    removeErrors (title) {
      this.$delete(this.formErrors, title)
    },
    formValidation () {
      this.formErrors = {}
      if (!this.validateCPR()) {
        this.$set(this.formErrors, 'ssn', 'Er ikke et gyldigt CPR nummer')
      }
    },
    validateCPR () {
      const ssn = this.ssn.replace(/[^0-9]/ig, '')
      return ssn.length === 10
    },
    resetForm () {
      this.ssn = this.user.ssn
      this.formErrors = {}
    },
    cancel () {
      this.resetForm()
      this.isEditable = false
    },
    submit () {
      this.formValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      this.isSaving = true
      let changes = {ssn: this.ssnTrimmed}
      docendo.updateUser(changes, success => {
        eventbus.toast = {text: 'Gemt', 'success': true}
        const obj = {
          prop: 'ssn',
          ssn: success.ssn
        }
        this.$store.commit('updateUserProp', obj)
        this.isSaving = false
        this.cancel()
      }, failure => {
        eventbus.toast = {text: 'CPR nummer er allerede brugt', 'success': false}
        this.isSaving = false
      })
    }
  },
  beforeMount () {
    this.ssn = this.user.ssn
  }
}
</script>

<style :scoped>
@import "../../assets/css/variables.css";

.d-profile__form {
  position: relative;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
  border-radius: 4px;
  padding-top: 1rem;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.d-profile__form__edit {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  color: var(--purple);
  font-weight: bold;
  cursor: pointer;
}

.d-input-group input {
  margin-top: 0.25rem;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.d-profile__form__submit {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
  background: #f9fafb;
  padding: 1rem;
}

.d-profile__form__submit button {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.d-input-group {
  margin: 1rem;
}

.d-input-group__un-edit {
  padding: 0rem 1rem 1rem 1rem;
}
</style>



// WEBPACK FOOTER //
// ProfileSSN.vue?0314e5a4